import { cn } from 'utils'

import classes from './pagination-item.module.css'

export const Dots = () => {
  return <li className={cn(classes.item, classes.link, classes.dots)}>...</li>
}
